import { English } from '../lang/en';
import { Spanish } from '../lang/es';
import { Portuguese } from '../lang/pt';
import { useUserDataStore } from '../newStore/userDataStore';
import { LangParam, LangTree } from '../types';


export function useLanguage() {
  const langDict: Record<LangParam, LangTree> = { en: English, es: Spanish, pt: Portuguese };

  const { lang } = useUserDataStore();

  return langDict[lang];
}
